import React, { Component, Fragment } from "react";

import classes from "./LoanCalculator.module.css";

class LoanCalculator extends Component {

    state = {
        loanValue: '',
        downPayment: '',
        term: '',
        rate: '',
        showEstimated: false,
        payment: null,
        error: false

    }

    loanCalculatHandler = (formEle, loanValue, downPayment, term, rate) => {
        if (rate > 1) {
            rate = rate * 0.01;
        }
        const monthlyRate = rate / 12;
        const factor = Math.pow(monthlyRate + 1, term);
        const numerator = monthlyRate * factor;
        const denominator = factor - 1;
        const quotient = numerator / denominator;
        const payment = (loanValue - downPayment) * quotient;
        if (payment > 0) {
            return ('$' + payment.toFixed(2));
        }
        else {
            this.setState({ error: true })
            for (let i = 0; i < 4; i++) {
                formEle[i].style.color = 'red';
                formEle[i].style.borderColor = 'red';
            }

        }

    }

    render() {
        return (
            <Fragment>
                <h1 style={{ paddingBottom: '4%', borderBottom: '1px solid #E4E4E4' }}>Car Loan Calculator</h1>
                <form
                    className={classes.LoanForm}
                    onSubmit={event => {
                        event.preventDefault()
                        if (event.target[4].innerText === 'Rest') {
                            this.setState({
                                loanValue: '',
                                downPayment: '',
                                term: '',
                                rate: '',
                                payment: null,
                                error: false
                            })
                            for (let i = 0; i < 4; i++) {
                                event.target[i].style.color = 'inherit';
                                event.target[i].style.borderColor = '#E4E4E4';
                            }
                        }
                        else {
                            const payment = this.loanCalculatHandler(event.target, this.state.loanValue, this.state.downPayment, this.state.term, this.state.rate)
                            this.setState({ payment: payment })
                        }
                        this.setState((prevState) => { return { showEstimated: !prevState.showEstimated } })
                    }}
                >
                    <input
                        type='number'
                        min='0'
                        placeholder='Total Loan Value'
                        value={this.state.loanValue}
                        onChange={(event) => {
                            this.setState({
                                loanValue: event.target.value
                            })
                        }} />
                    <input
                        type='number'
                        min='0'
                        placeholder='Down Payment'
                        value={this.state.downPayment}
                        onChange={(event) => {
                            this.setState({
                                downPayment: event.target.value
                            })
                        }} />
                    <input
                        type='number'
                        min='0'
                        placeholder='Loan Term (in months)'
                        value={this.state.term}
                        onChange={(event) => {
                            this.setState({
                                term: event.target.value
                            })
                        }} />
                    <input
                        type='number'
                        min='0'
                        placeholder='Intrest Rate%'
                        value={this.state.rate}
                        onChange={(event) => {
                            this.setState({
                                rate: event.target.value
                            })
                        }} />
                    <h2>{this.state.payment ? this.state.payment : null}</h2>
                    {this.state.error ?
                        <ul className={classes.Error}>
                            <li style={{ color: 'red', fontWeight: '200', fontSize: '.7rem' }}>Down payment should be less than loan value</li>
                            <li style={{ color: 'red', fontWeight: '200', fontSize: '.7rem' }}>Loan value, rate and term are required values</li>
                        </ul>
                        :
                        null
                    }
                    <button type='submit' className={classes.Btn}>{!this.state.showEstimated ? 'Estimated Payment' : 'Rest'}</button>
                </form>
            </Fragment>
        );
    }
}

export default LoanCalculator;